//
// Copyright (c) 2008-2025 Barry E. Mapen All Rights Reserved
//
import React, { useState, useEffect, useCallback } from 'react';
import Container from 'react-bootstrap/Container';
import { Outlet, useNavigate, useParams, useResolvedPath } from 'react-router-dom';

import { ReservationTable } from './ReservationTable';
import * as choiceApi from '../../api/choice';
import { eventDateString } from '../../common/misc';

import './Reservations.scss';


export function Reservation({
    item,
}) {

    if (!item) {
        return null;
    }

    const event = item.event;

    const dateStr = eventDateString(event);

    return (
        <div className="reservation">
            <div className="event-icon d-none d-md-block">
                <img src={`/event_icons/${event.icon}`} alt="event icon" />
            </div>
            <div className="event-content">
                <div className="event-header">
                    <div className="event-title">{event.title}</div>
                    <div className="event-date">{dateStr}</div>
                    <div className="event-icon d-md-none">
                        <img src={`/event_icons/${event.icon}`} alt="event icon" />
                    </div>
                </div>
                <div className="event-body">
                    <ReservationTable reservation={item.reservation} event={event} />
                </div>
            </div>
        </div>
    );
}


// TODO: only load minimal set of information for the reservations and provide a "refresh" function to children
export function Reservations(props) {
    const navigate = useNavigate();
    const selfUrl = useResolvedPath('.').pathname;
    const { eventId } = useParams();

    const [items, setItems] = useState([]);
    const [covidAck, setCovidAck] = useState(new Date().toISOString().split('T')[0]); //TODO: move this to the sessionStorage and keep a shadow copy here
    const [directRoute, setDirectRoute] = useState(!!eventId)

    const loadReservations = useCallback(async () => {
        const data = await choiceApi.getReservations();
        if (data) {
            setItems(data.map((x) => ({
                event: x.event,
                reservation: {
                    ...x.reservation, //TODO: should be able to remove this since nothing is using originalStatusId any more.  we have that from initial
                    originalStatusId: ((x.reservation.id === null) || (x.reservation.statusId === 0)) ? choiceApi.RESERVATION_STATUS_PENDING : choiceApi.RESERVATION_STATUS_CONFIRMED,
                }
            })));
        }
    }, [])

    useEffect(() => {
        loadReservations();
    }, [loadReservations])

    const onComplete = async (modified) => {
        //console.log(`onComplete`, directRoute, selfUrl)
        if (modified) {
            loadReservations();
        }
        if (directRoute) {
            //console.log(`going to ${selfUrl}`)
            setDirectRoute(false);
            navigate(selfUrl, {replace: true});
        }
        else {
            //console.log(directRoute);
            navigate(-1);
        }
    }    

    const selected = items.find((x) => x.event.id === eventId);

    const displayItems = items.map((x) => <Reservation key={`event-${x.event.id}`} item={x} /> );


    return (
        <Container className="reservation-list">
            <h1>Reservations to Upcoming Events</h1>
            {displayItems}

            <Outlet context={{
                event: selected?.event,
                reservation: selected?.reservation,
                onComplete: onComplete,
                covidAck: covidAck,
                setCovidAck: setCovidAck,
                loadReservations: loadReservations,
            }}/>
        </Container>
    );
}
